import Layout from "../components/Layout"
import SearchBox from "../components/SearchBox";
import {faFilter, faSpinner} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import Pagination from "../components/Pagination";
import Faq from "../components/Faq";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import ApiRoute, {shopId} from "../helper/api";
import ProductFagTab from "../components/ProductFag/ProductFagTab";
import ShopSelect from "../components/Shop/ShopSelect";

function Faqs() {
    const navigate = useNavigate()
    const [createModal, setCreateModal] = useState(false)

    const [isLoading, setIsLoading] = useState(true)
    const [updateData, setUpdateData] = useState('0')
    const [pageNumber, setPageNumber] = useState(1)
    const [shop_id, setShopId] = useState('')
    const [data, setData] = useState({})
    const [searchQuery, setSearchQuery] = useState({
        term: '',
        by: 'title'
    })
    const [filterQuery, setFilterQuery] = useState({})

    // state tab for filtering
    const [statsTab , setStatsTab] = useState(null)
    const [selectedStatsTab , setSelectedStatsTab] = useState('')

    // اضافه کردن state جدید برای وضعیت فیلتر
    const [filterStatus, setFilterStatus] = useState('all') // مقادیر: 'all', 'approved', 'unapproved'

    //fetch data from server and update data /| based on updateData state
    useEffect(() => {
        (async () => {
            setIsLoading(true)
            filterQuery.shop_id = shop_id
            filterQuery.model = '\\App\\QuestionManager\\Model\\QuestionExpanded'
            const  res  = await ApiRoute.product.question.index.fn({
                page : pageNumber,
            },filterQuery)
            setData(res)
            setIsLoading(false)
        })();
    }, [updateData]);

    const paginationData = data?.results
    const tableData = data?.results?.data ?? []

    // watch pageNumber and update updateData state
    useEffect(() => {
        setUpdateData(Date.now().toString())
    }, [pageNumber]);
    // watch searchQuery and update updateData state
    useEffect(() => {
        filterQuery.quick_search = searchQuery
        setUpdateData(Date.now().toString())
    }, [searchQuery]);

    // اضافه کردن useEffect برای اعمال فیلتر
    useEffect(() => {
        if (filterStatus !== 'all') {
            filterQuery.status = filterStatus;
        } else {
            delete filterQuery.status;
        }
        setUpdateData(Date.now().toString());
    }, [filterStatus]);

    return (
        <Layout>
            <div>
                <div className="page-title mb-3"><span className="inline-block bg-white pl-3">پرسش و پاسخ</span></div>
                <div className="flex gap-3">
                    <SearchBox SetSearchQuery={setSearchQuery} SearchIn={false}/>
                </div>

                <ProductFagTab options={data?.meta_data?.stats} selectedTab={filterStatus} setSelectedTab={setFilterStatus}/>

                <div className="my-3">
                    <ShopSelect
                        hasFrontEnd={true}
                        assignItem={(shop) => {
                            setShopId(shop?._id)
                            setUpdateData(Date.now().toString())
                        }}
                        multiple={false}
                        defaultValue={shop_id}
                    />
                </div>

                <div className="lg:border border-gray-7 rounded-md lg:p-3 mt-4 grid gap-4">
                    {isLoading ? (
                       <div className="flex justify-center items-center py-10">
                        <FontAwesomeIcon icon={faSpinner} spin className="text-3xl text-purple-600" />
                        </div>
                    ) : (
                        <>
                            {data && tableData.map((item) => (
                                <Faq 
                                    key={`faq-${item._id}-${filterStatus}`}
                                    setUpdateData={setUpdateData} 
                                    item={item} 
                                    hasAnswer={true}
                                />
                            ))}
                            <Pagination SetPageNumber={setPageNumber} Data={paginationData}/>
                        </>
                    )}
                </div>
            </div>
        </Layout>
    );
}

export default Faqs;